import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { SiteGroupEntity } from "src/app/features/SiteGroup/types/SiteGroupEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { orgUnitStatusSelectorConfig, siteGroupsSelectConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";
import { getAssignedDataGroup } from "../../../../../core/router/auth";

const SITE_GROUP_ID_COLUMN_DATA_GROUP_TYPES = new Set(["APAC", "IPASO"]);

export const SiteGroupsSearchForm: FC<SearchFormProps<SiteGroupEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    const formConfigName = getAssignedDataGroup()?.formConfigName?.toUpperCase();
    const hideSiteGroupIdColumn = Boolean(formConfigName && !SITE_GROUP_ID_COLUMN_DATA_GROUP_TYPES.has(formConfigName));

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("orgUnitsSearchForm.parentSiteName")} name="parentSiteId">
                <SelectDynamic name="parentSiteId" label={t("orgUnitsSearchForm.parentSiteName")} fieldConfig={siteGroupsSelectConfig} />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={orgUnitStatusSelectorConfig} />
            </Form.Item>
            <Form.Item label={t("orgUnitsSearchForm.siteGroupId")} name="siteGroupId" hidden={hideSiteGroupIdColumn}>
                <TextInput name="siteGroupId" />
            </Form.Item>
        </SearchForm>
    );
};
